import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Container,
  Card,
  CardContent,
  Avatar,
  CircularProgress,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../Api/ApiUrls";
import { AuthContext } from "../../AuthContext/AuthContext";
import CustomBottomNavbar from "../../Users/Post Module/FormsBottomNavbar";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteFailureAlert from '../../../Components/Users/Alertpage/DeleteAlert/DeleteFailureAlert';
import DeleteSuccessAlert from '../../../Components/Users/Alertpage/DeleteAlert/DeleteSuccessAlert';
import DeleteConfirmAlert from '../../../Components/Users/Alertpage/DeleteAlert/DeleteConfirmAlert';


const WantedProperties = () => {
  const navigate = useNavigate();
  const { userId } = useContext(AuthContext);
  const [responses, setResponses] = useState({});
  const [openResponses, setOpenResponses] = useState({});
  const [deletingId, setDeletingId] = useState(null);


  const [data, setData] = useState([]); 
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
const [showDeleteFailure, setShowDeleteFailure] = useState(false);
const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
const [requestToDelete, setRequestToDelete] = useState(null);
const [alertMessage, setAlertMessage] = useState("");

  const colors = {
    primary: "#1a1a1a",
    secondary: "#8B7355",
    accent: "#A52A2A",
    background: "#b9a990",
    cardBackground: "#FFFFFF",
    textDark: "#1a1a1a",
    textLight: "#FFFFFF",
    textMuted: "#666666"
  };

useEffect(() => {
  const fetchData = async () => {
    try {
      console.log("🚀 Fetching data...");
      console.log("👤 User ID:", userId);

      const [reqRes, respRes] = await Promise.all([
        axios.get(`${BASE_URL}/property-request/?user_id=${userId}`),
        axios.get(`${BASE_URL}/response-property-request/`),
      ]);

      console.log("📥 Property Requests API Response:", reqRes.data);
      console.log("📥 Response Property Requests API Response:", respRes.data);

      // ✅ Handle paginated response - no need to filter by user_id anymore
      const userProperties = (
        reqRes.data.results ||
        reqRes.data.data ||
        reqRes.data ||
        []
      ).reverse();

      console.log("✅ User Properties:", userProperties);

      // group responses by req_id
      const groupedResponses = respRes.data.reduce((acc, item) => {
        console.log("📌 Processing Response:", item.id, "req_id:", item.req_id);

        if (!acc[item.req_id]) {
          acc[item.req_id] = [];
        }

        acc[item.req_id].push(item);

        return acc;
      }, {});

      console.log("✅ Grouped Responses:", groupedResponses);

      setData(userProperties);
      setResponses(groupedResponses);

      console.log("🎯 Final Data Set:", userProperties);
      console.log("🎯 Final Responses Set:", groupedResponses);

      setLoading(false);
    } catch (err) {
      console.error("❌ Error Fetching Data:", err);

      if (err.response) {
        console.error("📛 Error Response:", err.response.data);
        console.error("📛 Status:", err.response.status);
      }

      setError("Failed to load data");
      setLoading(false);
    }
  };

  if (userId) {
    console.log("✅ User authenticated, fetching data...");
    fetchData();
  } else {
    console.warn("⚠️ User not authenticated. userId:", userId);
    setError("User not authenticated");
    setLoading(false);
  }
}, [userId]);

 const formatBudget = (min, max) => {
  if (!min && !max) return "Not specified";
  
  const formatNumber = (num) => {
    const numValue = parseFloat(num) || 0;
    
    if (numValue >= 10000000) { // 1 Crore+
      return `₹${(numValue / 10000000).toFixed(1)} Cr`;
    } else if (numValue >= 100000) { // 1 Lakh+
      return `₹${(numValue / 100000).toFixed(1)} L`;
    } else if (numValue >= 1000) { // 1 Thousand+
      return `₹${(numValue / 1000).toFixed(1)} K`;
    } else {
      return `₹${numValue}`;
    }
  };
  
  const minNum = parseFloat(min) || 0;
  const maxNum = parseFloat(max) || 0;
  
  if (minNum === maxNum) return formatNumber(minNum);
  
  const minFormatted = formatNumber(minNum);
  const maxFormatted = formatNumber(maxNum);
  
  // If both have same suffix, show only once
  const getSuffix = (str) => {
    if (str.includes('Cr')) return 'Cr';
    if (str.includes('L')) return 'L';
    if (str.includes('K')) return 'K';
    return '';
  };
  
  const minSuffix = getSuffix(minFormatted);
  const maxSuffix = getSuffix(maxFormatted);
  
  if (minSuffix && minSuffix === maxSuffix) {
    const minValue = minFormatted.replace(` ${minSuffix}`, '').replace('₹', '');
    const maxValue = maxFormatted.replace(` ${maxSuffix}`, '').replace('₹', '');
    return `₹${minValue}-${maxValue} ${minSuffix}`;
  }
  
  return `${minFormatted} - ${maxFormatted}`;
};

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    
    if (diffDays === 0) return "Today";
    if (diffDays === 1) return "Yesterday";
    if (diffDays < 7) return `${diffDays} days ago`;
    if (diffDays < 30) return `${Math.floor(diffDays / 7)} weeks ago`;
    return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
  };

  const formatDimensions = (property) => {
    if (property.length > 0 && property.width > 0) {
      const area = property.length * property.width;
      const units = property.units || 'ft';
      return `${property.length}*${property.width} (${area}) ${units === 'm' ? 'sq m' : 'sq ft'}`;
    }
    return null;
  };

  const toggleResponse = (reqId) => {
    setOpenResponses(prev => ({
      ...prev,
      [reqId]: !prev[reqId]
    }));
  };

  const handleViewAllResponses = (property) => {
    navigate("/all-responses", {
      state: {
        responses: responses[property.req_id] || [],
        property
      }
    });
  };

const handleDeleteRequest = (e, request) => {
  e.stopPropagation();
  setRequestToDelete(request);
  setShowDeleteConfirm(true);
};
const performDelete = async () => {
  if (!requestToDelete) return;
  
  setDeletingId(requestToDelete.req_id);
  
  try {
    await axios.delete(`${BASE_URL}/property-request/${requestToDelete.req_id}/`);
    
    // Remove the deleted request from state
    setData(prevData => prevData.filter(item => item.req_id !== requestToDelete.req_id));
    
    setAlertMessage("Property request deleted successfully!");
    setShowDeleteSuccess(true);
    
  } catch (err) {
    console.error("Error deleting property request:", err);
    setAlertMessage("Failed to delete property request. Please try again.");
    setShowDeleteFailure(true);
  } finally {
    setDeletingId(null);
    setRequestToDelete(null);
  }
};

  // ==================== BLACK SPINNER WHILE LOADING ====================
  if (loading) {
    return (
      <Box
        sx={{
          backgroundColor: 'rgb(239, 231, 221)',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 3,
        }}
      >
        <CircularProgress size={40} thickness={5} sx={{ color: '#000000' }} />
        <Typography variant="h7" sx={{ color: '#000000', fontWeight: 600 }}>
          Loading Wanted properties...
        </Typography>
      </Box>
    );
  }
  if (error) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: colors.background, justifyContent: "center", alignItems: "center" }}>
        <Typography variant="h6" color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: colors.background }}>
      {/* ===================== TOP BAR ===================== */}
      <AppBar position="fixed" sx={{ backgroundColor: colors.primary, color: colors.textLight ,zIndex: 1200}}>
        <Toolbar>
          <IconButton onClick={() => navigate(-1)} sx={{ color: colors.textLight }}>
            <ArrowBackIosNewIcon />
          </IconButton>
          <Typography variant="h6" sx={{ ml: 2 }}>Wanted Properties</Typography>
        </Toolbar>
      </AppBar>

      {/* ===================== CONTENT ===================== */}
      <Box sx={{ p: 1.5, flex: 1,  pt: { xs: '80px', sm: '100px' },pb: 10, backgroundColor: colors.background }}>
        {data.length === 0 ? (
          <Typography variant="h6" textAlign="center" sx={{ mt: 4, color: colors.textDark }}>
            No property requests found
          </Typography>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            {data.map((property) => (
              <Card 
                key={property.req_id}
                sx={{ 
                  borderRadius: 2, 
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)', 
                  border: `1px solid #e0e0e0`, 
                  overflow: 'hidden',
                  cursor: 'pointer',
                  '&:hover': {
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    transform: 'translateY(-2px)',
                    transition: 'all 0.2s ease'
                  }
                }}
                onClick={(e) => {
                  // Only navigate if the click is not on interactive elements
                  if (!e.target.closest('.no-navigate') && 
                      !e.target.closest('button') && 
                      !e.target.closest('a')) {
                    navigate(`/wanted-prop-details/${property.req_id}`);
                  }
                }}
              >
                <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
                  {/* Header section - Clickable area */}
                  <Box 
                    sx={{ 
                      p: 1, 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'space-between', 
                      backgroundColor: colors.primary,
                      cursor: 'pointer'
                    }}
                  >
                    {/* Purchase Section */}
                    <Box sx={{ 
                      backgroundColor: "#b9a990", 
                      color: colors.primary,
                      px: 1.5,
                      py: 0.5,
                      borderRadius: 3,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <Typography variant="h6" fontWeight="bold" sx={{ fontSize: '0.9rem', lineHeight: 1 }}>
                        {property.looking_for ? property.looking_for.charAt(0).toUpperCase() + property.looking_for.slice(1) : "Property"}
                      </Typography>
                    </Box>
                    
                    {/* Budget Section */}
                    <Box sx={{ 
                      backgroundColor: colors.cardBackground, 
                      color: colors.primary,
                      px: 1.5,
                      py: 0.5,
                      borderRadius: 3,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <Typography variant="subtitle1" fontWeight="bold" sx={{ lineHeight: 1, fontSize: '0.9rem' }}>
                        Budget: {formatBudget(property.min_budget, property.max_budget)}
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ p: 1.5 }}>
                    <Box sx={{ display: 'grid', gap: 0.75 }}>
                      {/* Type */}
                      <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                        <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 90, flexShrink: 0 }}>
                          <strong>Property Type:</strong>
                        </Typography>
                        <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
                          {property.property_type || "Not specified"}
                        </Typography>
                      </Box>

                      {/* Location */}
                      <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                        <Typography
                          variant="body2"
                          color={colors.textDark}
                          sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 90, flexShrink: 0 }}
                        >
                          <strong>Location:</strong>
                        </Typography>
                        <Typography variant="body2">
                          {property.pro_loc?.length > 0 ? (
                            property.pro_loc.map(loc => (
                              <div key={loc.loc_id}>• {loc.location}</div>
                            ))
                          ) : (
                            "Not specified"
                          )}
                        </Typography>
                      </Box>

                      {/* Dimensions when available */}
                      {formatDimensions(property) && (
                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                          <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 90, flexShrink: 0 }}>
                            <strong>Length*Width:</strong>
                          </Typography>
                          <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
                            {formatDimensions(property)}
                          </Typography>
                        </Box>
                      )}
                      
                      {/* Fallback to area if dimensions not available */}
                      {(property.area > 0 && !formatDimensions(property)) && (
                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                          <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 90, flexShrink: 0 }}>
                            <strong>Length*Width:</strong>
                          </Typography>
                          <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
                            {`${property.area} ${property.units || 'sq ft'}`}
                          </Typography>
                        </Box>
                      )}
                      
                      {/* Fallback to acres if neither dimensions nor area available */}
                      {((property.min_acres > 0 || property.max_acres > 0) && !formatDimensions(property) && property.area <= 0) && (
                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                          <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 90, flexShrink: 0 }}>
                            <strong>Length*Width:</strong>
                          </Typography>
                          <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
                            {`${property.min_acres}${property.max_acres > property.min_acres ? `-${property.max_acres}` : ''} acres`}
                          </Typography>
                        </Box>
                      )}
                      
                      {/* Ratio */}
                      {property.ratio && (
                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                          <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 80, flexShrink: 0 }}>
                            <strong>Ratio:</strong>
                          </Typography>
                          <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
                            {property.ratio}
                          </Typography>
                        </Box>
                      )}

                      {/* User and Date - REMOVED the negative margin */}
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 0.5 }}>
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                          <Avatar sx={{ width: 16, height: 16, fontSize: '0.5rem', mr: 0.5 }}>
                            👤
                          </Avatar>
                          <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2, minWidth: 75, flexShrink: 0, mr: 0.5 }}>
                            <strong>CUST {property.user_id}</strong>
                          </Typography>
                          <Typography variant="body2" color={colors.textDark} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
                            {formatDate(property.created_at)}
                          </Typography>
                        </Box>

                      <IconButton
  onClick={(e) => handleDeleteRequest(e, property)}
  disabled={deletingId === property.req_id}
  className="no-navigate"
  sx={{
    width: 32,
    height: 32,
    zIndex: 10,
    position: 'relative',
    "&:hover": {
      backgroundColor: "#ffebee",
    }
  }}
>
  {deletingId === property.req_id ? (
    <CircularProgress size={20} sx={{ color: "#ff4444" }} />
  ) : (
    <DeleteIcon sx={{ color: "#ff4444", fontSize: 20 }} />
  )}
</IconButton>
                      </Box>
                    </Box>

                    {/* ================= RESPONSES ================= */}
                    {responses[property.req_id]?.length > 0 && (
                      <Box 
                        className="no-navigate"
                        sx={{ mt: 1.5, pt: 1, borderTop: '1px dashed #ccc' }}
                      >
                        {/* Show / Hide button */}
                        <Typography
                          onClick={() => toggleResponse(property.req_id)}
                          sx={{
                            fontSize: '0.75rem',
                            fontWeight: 600,
                            mb: 0.5,
                            cursor: 'pointer',
                            color: '#a89478ff'
                          }}
                        >
                          {openResponses[property.req_id] ? 'Hide Responses' : 'Show Responses'} ({responses[property.req_id].length})
                        </Typography>

                        {/* Expanded content */}
                        {openResponses[property.req_id] && (
                          <>
                            {/* Show only FIRST response */}
                            <Box
                              sx={{
                                backgroundColor: '#f7f4ef',
                                borderRadius: 1,
                                p: 0.75,
                                mb: 0.5
                              }}
                            >
                              <Typography sx={{ fontSize: '0.75rem' }}>
                                {responses[property.req_id][0].comment}
                              </Typography>

                              {responses[property.req_id][0].proerty_link && (
                                <Typography
                                  component="a"
                                  href={responses[property.req_id][0].proerty_link}
                                  onClick={(e) => e.stopPropagation()}
                                  sx={{
                                    fontSize: '0.7rem',
                                    color: '#1a1a1a',
                                    display: 'block',
                                    mt: 0.3,
                                    textDecoration: 'underline',
                                    cursor: 'pointer'
                                  }}
                                >
                                  View Property
                                </Typography>
                              )}

                              <Typography sx={{ fontSize: '0.65rem', opacity: 0.6, mt: 0.3 }}>
                                {formatDate(responses[property.req_id][0].created_at)}
                              </Typography>
                            </Box>

                            {/* +N more */}
                            {responses[property.req_id].length > 1 && (
                              <Typography
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleViewAllResponses(property);
                                }}
                                sx={{
                                  fontSize: '0.7rem',
                                  fontWeight: 600,
                                  cursor: 'pointer',
                                  color: '#8B7355'
                                }}
                              >
                                +{responses[property.req_id].length - 1} more
                              </Typography>
                            )}
                          </>
                        )}
                      </Box>
                    )}
                  </Box>
                </CardContent>
              </Card>
            ))}
          </Box>
        )}
      </Box>


      {/* Delete Success */}
      {showDeleteSuccess && (
        <DeleteSuccessAlert
          message={alertMessage}
          onClose={() => {
            setShowDeleteSuccess(false);
            setAlertMessage("");
          }}
        />
      )}
      
      {/* Delete Failure */}
      {showDeleteFailure && (
        <DeleteFailureAlert
          message={alertMessage}
          onClose={() => {
            setShowDeleteFailure(false);
            setAlertMessage("");
          }}
        />
      )}
{showDeleteConfirm && requestToDelete && (
  <DeleteConfirmAlert
    message={`Are you sure you want to delete this property request? This action cannot be undone.`}
    onOk={() => {
      setShowDeleteConfirm(false);
      performDelete();
    }}
    onCancel={() => {
      setShowDeleteConfirm(false);
      setRequestToDelete(null);
    }}
  />
)}
      {/* ===================== BOTTOM NAV ===================== */}
      <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1000 }}>
        <CustomBottomNavbar />
      </Box>
    </Box>
  );
};

export default WantedProperties;